<template>
  <div class="moban" style="padding-top: 50px;">
    <div class="head">
      <img src="../../static/image/mbxt.png" class="fullWidth" />
      <div class="head-t">
        <p>简云网络科技围绕为客户创造价值的初心，坚持为客户提供最适合的服务，为了满足标准需求的客户群体，简云科技自研或代理了诸多软件产品，目前有官网系统、商城系统、展示预约小程序、销售系统、门店营销系统、酒店预订</p>
        <p>、社区团购、餐饮系统、营销系统、公众号助手、微传单和企业邮箱等数十款模板软件产品。</p>
        <div class="btn" @click="jion_moban">
          进入模板系统
          <img src="../../static/image/yjt.png" alt />
        </div>
      </div>
    </div>
    <div class="Data_statistics">
      <ul>
        <li>
          <span>20,162,227</span>
          <span>/注册用户</span>
        </li>
        <li>
          <span>3360天</span>
          <span>/安全运行</span>
        </li>
        <li>
          <span style="position:relative">
            100
            <i style=" font-style: normal;position:absolute;right:-23px;top:-35px">+</i>
          </span>
          <span>/覆盖行业</span>
        </li>
      </ul>
    </div>
    <div class="moban_software">
      <div class="moban_software_left">
        <img src="../../static/image/saas.png" alt />
      </div>
      <div class="moban_software_right">
        <h2>什么是模板软件</h2>
        <p>模板软件即SaaS软件，它是Software-as-a-Service（软件即服务）的简称。随着互联网技术的发展和应用软件的成熟，在21世纪开始兴起的一种完全创新的软件应用模式。传统模式下，厂商通过License将软件产品部署到企业内部多个客户终端实现交付。SaaS定义了一种新的交付方式，也使得软件进一步回归服务本质。企业部署信息化软件的本质是为了自身的运营管理服务，软件的表象是一种业务流程的信息化，本质还是第一种服务模式，SaaS改变了传统软件服务的提供方式，减少本地部署所需的大量前期投入，进一步突出信息化软件的服务属性，或成为未来信息化软件市场的主流交付模式。</p>
      </div>
    </div>
    <div class="software-advantages">
      <h2 class="software-advantages-title">模板软件的优点</h2>
      <div class="software-advantages-list">
        <ul>
          <li>
            <img src="../../static/image/software-advantages-list1.png" alt />
            <p>免开发，免安装，免维护，开通即用</p>
          </li>
          <li>
            <img src="../../static/image/software-advantages-list2.png" alt />
            <p>按月或按年付费订阅，成本投入低</p>
          </li>
          <li>
            <img src="../../static/image/software-advantages-list3.png" alt />
            <p>会用即可，无需招聘专业IT人员</p>
          </li>
        </ul>
        <ul>
          <li>
            <img src="../../static/image/software-advantages-list4.png" alt />
            <p>云端部署，统一备份、维护、安全、升级</p>
          </li>
          <li>
            <img src="../../static/image/software-advantages-list5.png" alt />
            <p>先试用体验，满意后付款，终身技术支持</p>
          </li>
          <li>
            <img src="../../static/image/software-advantages-list6.png" alt />
            <p>正式使用后，专注核心业务经营即可</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="free_trial">
      <h2 class="free_trial_title">模板软件免费试用流程</h2>
      <div class="free_trial_lc">
        <div class="free_trial_lc_content">
          <ul>
            <li v-for='(item,i) in point' :key='i'>
              <div @mouseover="hover(i)" :class="[i==suoyin?'active1':'']"></div>
              <div  :class="[i==suoyin?'active2':'']">
                {{item.wz}}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <xfck></xfck>
  </div>
</template>

<script>
import xfck from "./xfck.vue";
export default {
  name: "jiaru",
  data() {
    return {
          point:[
             {wz:'打开网址“www.jianyunkeji.net”，点击“注册账号”申请账号。'},
             {wz:'选择想要试用的SAAS软件产品开通试用。'},
             {wz:'如试用合适联系简云科技商务人员付费开通正式版。'},
             {wz:' 开通付费版后，简云科技提供功能使用培训和终身技术支持服务。'}
          ],
          suoyin:''
    };
  },
  created() {},
  methods: {
    jion_moban() {
      window.open("http://www.jianyunkeji.net/");
    },
    hover(index){
      this.suoyin = index;
    }
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.head {
  position: relative;
}
.head-t {
  /* width: 100%; */
  text-align: center;
  position: absolute;
  bottom: 50%;
  font-size: 18px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  width: 918px;
  left: 50%;
  transform: translateX(-50%);
  line-height: 30px;
}
.btn {
  display: flex;
  justify-content: space-around;
  font-size: 44px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  width: 400px;
  height: 100px;
  background: rgba(53, 139, 236, 1);
  border-radius: 10px;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: -200px;
  transform: translateX(-50%);
  cursor: pointer;
}
.Data_statistics {
  width: 100%;
  padding: 50px 0;
  border-bottom: 2px solid rgba(245, 245, 245, 1);
}
.Data_statistics ul {
  width: 1200px;
  margin: 0 auto;
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Data_statistics ul li {
  position: relative;
}
.Data_statistics ul li:nth-child(2)::before {
  content: "";
  width: 2px;
  height: 120px;
  background: rgba(245, 245, 245, 1);
  position: absolute;
  left: -50%;
  top: -26px;
}
.Data_statistics ul li:nth-child(2)::after {
  content: "";
  width: 2px;
  height: 120px;
  background: rgba(245, 245, 245, 1);
  position: absolute;
  right: -50%;
  top: -26px;
}
.Data_statistics ul li span:nth-child(1) {
  font-size: 48px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(255, 137, 50, 1);
}
.Data_statistics ul li span:nth-child(2) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #8d8b8e;
}
.moban_software {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}
.moban_software_left {
  flex: 50%;
  position: relative;
}
.moban_software_left img {
  width: 447px;
  height: 342px;
  position: absolute;
  top: 83px;
  left: 14px;
}
.moban_software_right {
  flex: 50%;
}
.moban_software_right h2 {
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  margin-top: 205px;
}
.moban_software_right p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
  margin-top: 59px;
}
.software-advantages {
  margin-top: 96px;
  width: 100%;
  height: 668px;
  background: url("../../static/image/mbyd.png") no-repeat top center;
  background-size: 100% 100%;
  overflow: hidden;
}
.software-advantages-title {
  text-align: center;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  margin-top: 50px;
  position: relative;
}
.software-advantages-title::before {
  content: "";
  width: 80px;
  height: 3px;
  background: rgba(255, 255, 255, 1);
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
}
.software-advantages-list {
  width: 1200px;
  margin: 0 auto;
}
.software-advantages-list ul {
  list-style: none;
  display: flex;
  justify-content: space-between;
  margin-top: 106px;
}
.software-advantages-list ul li {
  width: 255px;
  height: 114px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.software-advantages-list ul li p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
}
.free_trial {
  width: 100%;
  margin-top: 120px;
  height: 500px;
}
.free_trial_title {
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  position: relative;
}
.free_trial_title::before {
  content: "";
  width: 80px;
  height: 3px;
  background: rgba(255, 137, 50, 1);
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -29px;
}
.free_trial_lc {
  height: 108px;
  background: url("../../static/image/lc.png") no-repeat top center;
  background-size: 100% 100%;
  margin-top: 231px;
}
.free_trial_lc_content {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
}
.free_trial_lc_content ul {
  list-style: none;
  display: flex;
  height: 100%;
}
.free_trial_lc_content ul li {
  height: 100%;
  flex: 25%;
  position: relative;
}
.free_trial_lc_content ul li:nth-child(1) div:nth-child(1) {
  left: 50%;
  transform: translateX(-50%);
  top: 12px;
}
.free_trial_lc_content ul li div:nth-child(2) {
  position: absolute;
  width: 221px;
  height: 38px;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(102, 102, 102, 1);
  line-height: 24px;
}
.free_trial_lc_content ul li div:nth-child(1) {
  position: absolute;
  width: 15px;
  height: 15px;
  background: #333;
  border-radius: 50%;
  cursor: pointer;
}
.free_trial_lc_content ul li:nth-child(1) div:nth-child(2) {
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
}
.free_trial_lc_content ul li:nth-child(2) div:nth-child(1) {
  left: 50%;
  transform: translateX(-50%);
  bottom: 41px;
}
.free_trial_lc_content ul li:nth-child(2) div:nth-child(2) {
  bottom: -40px;
  left: 50%;
  transform: translateX(-50%);
}
.free_trial_lc_content ul li:nth-child(3) div:nth-child(1) {
  left: 50%;
  transform: translateX(-50%);
  top: 20px;
}
.free_trial_lc_content ul li:nth-child(3) div:nth-child(2) {
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
}
.free_trial_lc_content ul li:nth-child(4) div:nth-child(1) {
  left: 50%;
  transform: translateX(-50%);
  bottom: -6px;
}
.free_trial_lc_content ul li:nth-child(4) div:nth-child(2) {
  bottom: -60px;
  left: 50%;
  transform: translateX(-50%);
}
 .free_trial_lc_content ul li div.active1{
  background: rgba(255, 137, 50, 1);
}
 .free_trial_lc_content ul li div.active2{
  color: rgba(255, 137, 50, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/moban.vue